import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
import { sidebarActions } from "../../actions/sidebarActions";
import { switchTenantActions } from "../../actions/switchTenantActions";
import { userSelfEditActions } from "../../actions/userSelfEditActions";
var headerReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSidebar: function () { return dispatch({ type: sidebarActions.SHOW_SIDEBAR }); },
            onHideSidebar: function () { return dispatch({ type: sidebarActions.HIDE_SIDEBAR }); },
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
            onShowSelfEditUserList: function () { return dispatch({ type: userSelfEditActions.SHOW_SELF_EDIT_USER_LIST }); },
            onHideSelfEditUserList: function () { return dispatch({ type: userSelfEditActions.HIDE_SELF_EDIT_USER_LIST }); },
            onShowSelfEditUserModal: function () { return dispatch({ type: userSelfEditActions.SHOW_SELF_EDIT_USER_MODAL }); },
            onHideSelfEditUserModal: function () { return dispatch({ type: userSelfEditActions.HIDE_SELF_EDIT_USER_MODAL }); },
            onShowSelfEditPassModal: function () { return dispatch({ type: userSelfEditActions.SHOW_SELF_EDIT_PASS_MODAL }); },
            onHideSelfEditPassModal: function () { return dispatch({ type: userSelfEditActions.HIDE_SELF_EDIT_PASS_MODAL }); },
            onShowSwitchTenantButton: function () { return dispatch({ type: switchTenantActions.SHOW_SWITCH_TENANT_BUTTON }); },
            onHideSwitchTenantButton: function () { return dispatch({ type: switchTenantActions.HIDE_SWITCH_TENANT_BUTTON }); }
        };
    },
    mapStateToProps: function (state) {
        return {
            sidebarVisible: state.sidebarReducer.sidebarVisible,
            userSelfEditModalVisible: state.headerReducer.userSelfEditModalVisible,
            userSelfEditListVisible: state.headerReducer.userSelfEditListVisible,
            userSelfEditPassModalVisible: state.headerReducer.userSelfEditPassModalVisible,
            switchTenantButtonVisible: state.headerReducer.switchTenantButtonVisible
        };
    }
};
export default headerReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/components/Header/HeaderReduxProps.ts
// module id = 33
// module chunks = 0